<template>
  <div class="baggage-main">
    <!-- 头 -->
    <Header
      ref="header"
      style="z-index: 9999"
      :title="title"
      :showBack="!isFromDriver"
      :isFromDriver="isFromDriver"
    >
    </Header>

    <div class="baggage-check">
      <div class="baggage-check-card ">
        <van-form @submit="onSubmit">
          <div>
            <van-cell
              title="检查日期"
              :value="queryData.CheckDate"
              @click="isShowBaggageCheckDate = true"
              :border="false"
              class="baggage-cell"
              is-link
            />

            <van-cell
              title="检查时间"
              :value="queryData.CheckTime"
              @click="isShowBaggageCheckTime = true"
              :border="false"
              class="baggage-cell"
              is-link
            />

            <BaggagePicker
              label="线路"
              name="line"
              :parentSelectorActive="lineValue"
              @comfirm="clickComfirm"
            >
            </BaggagePicker>

            <van-field
              class="baggage-cell"
              v-model="queryData.BagItem"
              label="包内主要物品"
              placeholder="请输入包内主要物品"
              input-align="right"
              type="textarea"
              rows="1"
              autosize
            />
            <van-field
              class="baggage-cell"
              v-model="queryData.CheckContext"
              label="检查情况"
              placeholder="请输入检查情况"
              input-align="right"
              type="textarea"
              rows="1"
              autosize
            />
            <van-field
              class="baggage-cell"
              v-model="queryData.Cure"
              label="处理措施"
              placeholder="请输入处理措施"
              input-align="right"
              type="textarea"
              rows="1"
              autosize
            />
            <van-field
              class="baggage-cell"
              v-model="queryData.CheckSign"
              label="检查人签名"
              placeholder="请输入检查人签名"
              input-align="right"
            />
            <van-field
              class="baggage-cell"
              v-model="queryData.Notes"
              label="备注"
              placeholder="请输入备注"
              input-align="right"
              type="textarea"
              rows="1"
              autosize
            />
          </div>

          <div class="baggage-submit" style="margin-top: .3rem;">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              readonly
              required
            >
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

    <!-- 日期选择 -->
    <van-calendar
      v-model="isShowBaggageCheckDate"
      @confirm="confirmBaggageCheckDate"
      :default-date="new Date()"
    />
    <!-- 时间选择 -->
    <van-popup
      v-model="isShowBaggageCheckTime"
      position="bottom"
      @open="openBaggageCheckTimePopup"
    >
      <van-datetime-picker
        v-model="baggageCheckTime"
        type="time"
        title="选择时间"
        @confirm="confirmBaggageCheckTime"
        @cancel="isShowBaggageCheckTime = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BaggagePicker from "./components/BaggagePicker.vue";

export default {
  components: {
    Header,
    BaggagePicker,
  },
  data() {
    return {
      title: "行李异常登记", //标题
      isFromDriver: false,

      lineValue: {}, // 线路
      baggageCheckTime: "", // 检查时间
      isShowBaggageCheckDate: false, // 检查日期
      isShowBaggageCheckTime: false, // 检查时间

      queryData: {
        CheckDate: "",
        CreateGID: "",
        CreateCode: "",
        CreateName: "",
        CreateTime: "",
        GID: "",
        ModifyTime: "",
        ModifyGID: "",
        ModifyCode: "",
        ModifyName: "",
        CheckTime: "",
        LineGID: "",
        BagItem: "",
        CheckContext: "",
        Cure: "",
        CheckSign: "",
        Notes: "",
      },
    };
  },
  mounted() {
    this.getCurrentDateTime();
    this.getLocalData();
  },
  methods: {
    // 检查时间 弹出框 确定按钮
    confirmBaggageCheckTime(data) {
      this.queryData.CheckTime = data;
      this.isShowBaggageCheckTime = false;
    },
    openBaggageCheckTimePopup() {
      this.baggageCheckTime = this.queryData.CheckTime;
    },

    // 检查日期 弹出框 确定按钮
    confirmBaggageCheckDate(date) {
      this.queryData.CheckDate = this.$moment(date).format("YYYY-MM-DD");
      this.isShowBaggageCheckDate = false;
    },

    // 获取本地数据
    getLocalData() {
      let localData = this.$utils.localData.get("adminInfo", Object);
      this.queryData.CreateGID = localData.GID;
      this.queryData.ModifyGID = localData.GID;
      this.queryData.CreateName = localData.UserName;
      this.queryData.ModifyName = localData.UserName;
      this.queryData.CreateCode = localData.UserCode;
      this.queryData.ModifyCode = localData.UserCode;
      this.queryData.GID = localData.OrganizationGID;
    },
    // 获取当前日期时间
    getCurrentDateTime() {
      let date = this.$moment(this.$moment());
      this.queryData.CheckDate = date.format("YYYY-MM-DD");
      this.queryData.CreateTime = date.format("YYYY-MM-DD HH:mm:ss");
      this.queryData.ModifyTime = date.format("YYYY-MM-DD HH:mm:ss");
      this.queryData.CheckTime = date.format("HH:mm");
    },

    // 监听线路返回
    clickComfirm(data, type) {
      if (type === "line") {
        this.lineValue = data;
        this.queryData.LineGID = data.LineGID;
      }
    },

    // 点击提交
    onSubmit() {
      this.$http
        .post(this.$api.GuestNodeCustomerBagCheckCreate, {
          _JsonText: JSON.stringify(this.queryData),
        })
        .then((res) => {
          if (res.success) {
            this.$toast("添加成功");
            setTimeout(() => {
              this.$router.go(-1);
            }, 800);
          } else {
            this.$toast("添加失败 - " + res.msg);
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.baggage-main {
  .baggage-check {
    height: calc(100vh - 45px - 0.6rem);
    padding: 0.3rem;
    display: flex;
    flex-direction: column;

    .baggage-check-card {
      background-color: #fff;
      padding: 0.3rem;
      flex: 1;

      .van-form {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .baggage-cell {
          border-bottom: 1px solid #dddddd85;
          font-size: 0.42rem;
          /deep/ .van-cell__title {
            display: flex;
            justify-items: flex-start;
            color: #000;
          }
          .van-cell__value {
            color: #000;
          }
        }
        .van-cell::after {
          border: none;
        }

        .baggage-submit {
        }
      }
    }
  }
}
</style>
